module.exports = __webpack_public_path__ + "static/media/ar.dc2dcf68.svg";